import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as MessagingService from '_services/messaging-service';
import * as UserService from '_services/user-service';

const initialState = {
  status: "idle",
  nameFetchStatus: "idle",
  postMessageStatus: "idle",
  deleteStatus: "idle",
  archiveChatStatus: "idle",
  fetchConversationStatus: "idle",
  fetchMessagesStatus: "idle",
  notificationStatus: "idle",
  createSupportDeskStatus: "idle",
  allSupportDesks: [],                     // holds list of all support desks
  statusObj: {},
  conversations: [],
  messages: [],
  message: '',
  users: {},
  showArchive: false,
  error: null,
  selectedConversation: '',
  customAuthToken: '',
  supportDesk: {},
  supportDeskStatus: 'idle',
  search: "",
  customTokenStatus: "idle",
  unreadChats: 0
};

// get support desk info for iata
export const getSupportDesk = createAsyncThunk(
  "messaging/getSupportDesk",
  async (iata) => {
    return await MessagingService.getSupportDesk(iata)
  }
);

export const getAllSupportDesks = createAsyncThunk(
  "messaging/getAllSupportDesks",
  async () => {
    //return await MessagingService.getAllSupportDesks()
    return [];
  }
);

export const createSupportDesk = createAsyncThunk(
  "messaging/createSupportDesk",
  async (supportDesk) => {
    return await MessagingService.createSupportDesk(supportDesk)
  }
);

export const updateSupportDesk = createAsyncThunk(
  "messaging/updateSupportDesk",
  async (supportDesk) => {
    return await MessagingService.updateSupportDesk(supportDesk)
  }
);


// get user info 
export const getUserInfo = createAsyncThunk(
  "messaging/getUserInfo",
  async (id) => {
    return await UserService.getFirebaseInfo(id)
  }
);

// get all bookings
export const getConversations = createAsyncThunk(
  "messaging/getConversations",
  async (params) => {
    return await MessagingService.getConversations({ ...params })
  }
);

export const getMessages = createAsyncThunk(
  "messaging/getMessages",
  async (params) => {
    return await MessagingService.getMessages({ ...params })
  }
);

export const postMessage = createAsyncThunk(
  "messaging/postMessage",
  async (params) => {
    return await MessagingService.postMessage({ ...params })
  }
);

export const getCustomAuthToken = createAsyncThunk(
  "messaging/getCustomAuthToken",
  async () => {
    return await MessagingService.getCustomAuthToken()
  }
);

export const clearNotification = createAsyncThunk(
  "messaging/clearNotification",
  async (conversationId) => {
    return await MessagingService.clearNotification(conversationId)
  }
);

export const postNotification = createAsyncThunk(
  "messaging/postNotification",
  async (params) => {
    return await MessagingService.postNotification(params)
  }
);

export const deleteChat = createAsyncThunk(
  "messaging/deleteChat",
  async (id) => {
    return await MessagingService.deleteChat(id)
  }
);

export const archiveChat = createAsyncThunk(
  "messaging/archiveChat",
  async (params) => {
    return await MessagingService.archiveChat(params)
  }
);

const messagingSlice = createSlice({
  name: "messaging",
  initialState,
  reducers: {
    reset: (state) => initialState,
    setSelectedConversation: (state, action) => {
      return {
        ...state,
        selectedConversation: action.payload,
      }
    },
    setMessage: (state, action) => {
      return {
        ...state,
        message: action.payload,
      }
    },
    setShowArchive: (state, action) => {
      return {
        ...state,
        showArchive: action.payload,
      }
    },
    clearSelectedConversation: (state, action) => {
      return {
        ...state,
        selectedConversation: null,
      }
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    readAllChats: state => {
      state.unreadChats = 0
    },
    setUnreadChat: (state, action) => {
      if (!state.unreadChats) state.unreadChats = 0;
      state.unreadChats += +(action.payload)
    }
  },
  extraReducers: {
    [getConversations.pending]: (state, action) => {
      return {
        ...state,
        fetchConversationStatus: "loading",
        statusObj: { ...state.statusObj, getConversations: 'loading' },
      }
    },
    [getConversations.fulfilled]: (state, action) => {
      return {
        ...state,
        fetchConversationStatus: "succeeded",
        statusObj: { ...state.statusObj, getConversations: 'succeeded' },
        conversations: action.payload,
      }
    },
    [getConversations.rejected]: (state, action) => {
      return {
        ...state,
        fetchConversationStatus: "failed",
        statusObj: { ...state.statusObj, getConversations: 'failed' },
        error: action.error.message
      }
    },

    [getMessages.pending]: (state, action) => {
      return {
        ...state,
        fetchMessagesStatus: "loading",
        statusObj: { ...state.statusObj, getMessages: 'loading' },
      }
    },
    [getMessages.fulfilled]: (state, action) => {
      return {
        ...state,
        fetchMessagesStatus: "succeeded",
        statusObj: { ...state.statusObj, getMessages: 'succeeded' },
        messages: action.payload,
      }
    },
    [getMessages.rejected]: (state, action) => {
      return {
        ...state,
        fetchMessagesStatus: "failed",
        statusObj: { ...state.statusObj, getMessages: 'failed' },
        error: action.error.message
      }
    },
    [postMessage.pending]: (state, action) => {
      return {
        ...state,
        postMessageStatus: "loading",
        statusObj: { ...state.statusObj, postMessage: 'loading' },
      }
    },
    [postMessage.fulfilled]: (state, action) => {
      return {
        ...state,
        postMessageStatus: "succeeded",
        statusObj: { ...state.statusObj, postMessage: 'succeeded' },
        // message: action.payload,
      }
    },
    [postMessage.rejected]: (state, action) => {
      return {
        ...state,
        postMessageStatus: "failed",
        statusObj: { ...state.statusObj, postMessage: 'failed' },
        error: action.error.message
      }
    },
    [getCustomAuthToken.pending]: (state, action) => {
      return {
        ...state,
        status: "loading",
        customTokenStatus: "loading",
        statusObj: { ...state.statusObj, getCustomAuthToken: 'loading' },
      }
    },
    [getCustomAuthToken.fulfilled]: (state, action) => {

      return {
        ...state,
        status: "succeeded",
        customTokenStatus: "succeeded",
        statusObj: { ...state.statusObj, getCustomAuthToken: 'succeeded' },
        customAuthToken: action.payload
      }

    },
    [getCustomAuthToken.rejected]: (state, action) => {
      return {
        ...state,
        customTokenStatus: "failed",
        statusObj: { ...state.statusObj, getCustomAuthToken: 'failed' },
        status: "failed"
      }
    },
    [getUserInfo.pending]: (state, action) => {
      return {
        ...state,
        nameFetchStatus: "loading",
      }
    },
    [getUserInfo.fulfilled]: (state, action) => {
      const updatedUsers = {
        ...state.users,                         // Spread the existing users
        [action.payload.uid]: action.payload, // Add the new user using their UID as the key
      };

      return {
        ...state,
        users: updatedUsers,                  // Update the users object
        nameFetchStatus: 'succeeded',
      };
    },
    [getUserInfo.rejected]: (state, action) => {
      return {
        ...state,
        nameFetchStatus: "failed"
      }
    },
    [clearNotification.pending]: (state, action) => {
      return {
        ...state,
        status: "loading",
      }
    },
    [clearNotification.fulfilled]: (state, action) => {
      const updatedConversations = state.conversations.map((conversation) => {
        if (conversation.id === action.payload.conversationId) {
          return {
            ...conversation,
            notification: false,
          };
        }
        return conversation;
      });

      return {
        ...state,
        conversations: updatedConversations,
      };
    },
    [clearNotification.rejected]: (state, action) => {
      return {
        ...state,
      }
    },
    [postNotification.rejected]: (state, action) => {
      return {
        ...state,
        notificationStatus: "failed",
      }
    },
    [postNotification.pending]: (state, action) => {
      return {
        ...state,
        notificationStatus: "loading",
      }
    },
    [postNotification.fulfilled]: (state, action) => {
      return {
        ...state,
        notificationStatus: "successfully dispatched notification...",
      }
    },
    [deleteChat.rejected]: (state, action) => {
      return {
        ...state,
        deleteStatus: "failed",
      }
    },
    [deleteChat.pending]: (state, action) => {
      return {
        ...state,
        deleteStatus: "loading",
      }
    },
    [deleteChat.fulfilled]: (state, action) => {
      return {
        ...state,
        deleteStatus: "succeeded",
      }
    },
    [archiveChat.rejected]: (state, action) => {
      return {
        ...state,
        archiveChatStatus: "failed",
      }
    },
    [archiveChat.pending]: (state, action) => {
      return {
        ...state,
        archiveChatStatus: "loading",
      }
    },
    [archiveChat.fulfilled]: (state, action) => {
      return {
        ...state,
        archiveChatStatus: "succeeded",
      }
    },
    [getSupportDesk.rejected]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "failed",
      }
    },
    [getSupportDesk.pending]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "loading",
      }
    },
    [getSupportDesk.fulfilled]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "succeeded",
        supportDesk: action.payload
      }
    },
    [getAllSupportDesks.rejected]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "failed",
      }
    },
    [getAllSupportDesks.pending]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "loading",
      }
    },
    [getAllSupportDesks.fulfilled]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "succeeded",
        allSupportDesks: action.payload
      }
    },
    [updateSupportDesk.rejected]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "failed",
      }
    },
    [updateSupportDesk.pending]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "loading",
      }
    },
    [updateSupportDesk.fulfilled]: (state, action) => {
      return {
        ...state,
        supportDeskStatus: "succeeded",
        supportDesk: action.payload
      }
    },
    [createSupportDesk.rejected]: (state, action) => {
      return {
        ...state,
        createSupportDeskStatus: "failed",
      }
    },
    [createSupportDesk.pending]: (state, action) => {
      return {
        ...state,
        createSupportDeskStatus: "loading",
      }
    },
    [createSupportDesk.fulfilled]: (state, action) => {
      return {
        ...state,
        createSupportDeskStatus: "succeeded",
        supportDesk: action.payload
      }
    }
  },
});

export const selectReceipientsInformation = (state) => {
  if (state.messaging.users && state.messaging.users != null && state.messaging.users == undefined && state.messaging.users != {}) {
    return {}
  }

  return state.messaging.users

}

export const selectMessages = (state) => {
  if (state.messaging.messages == null || state.messaging.messages == undefined) {
    return [];
  }

  let messages = state.messaging.messages;

  // Convert Firebase timestamps to JavaScript Date objects
  const messagesWithDates = messages.map((message) => ({
    ...message,
    timeStamp: new Date(message.timeStamp.seconds * 1000),
  }));

  // Group messages by date and hour
  const groupedMessages = messagesWithDates.reduce((result, message) => {
    const dateKey = message.timeStamp.toISOString().split(':').slice(0, 2).join(':'); // Extract date and hour as 'YYYY-MM-DDTHH:mm'
    result[dateKey] = result[dateKey] || [];
    result[dateKey].push(message);
    return result;
  }, {});

  // Sort groups by date and hour in ascending order
  const sortedGroupedMessages = Object.entries(groupedMessages)
    .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
    .reduce((result, [date, messages]) => {
      result[date] = messages;
      return result;
    }, {});

  return sortedGroupedMessages;
};


export const selectConversations = (state) => {
  if (!state.messaging.conversations || state.messaging.conversations.length === 0) {
    return [];
  }

  // remove empty conversations
  let sanitizedConversations = [];

  state.messaging.conversations.forEach((conversation) => {
    if (conversation.lastAction != undefined) {
      sanitizedConversations.push(conversation);
    }
  });

  let tempList = [];

  // Filter conversations based on the showArchive flag
  tempList = sanitizedConversations.filter((conversation) => {
    if (state.messaging.showArchive) {
      return conversation.archived === true;
    } else {
      return !conversation.archived;
    }
  });

  tempList.sort((a, b) => {

    if (a.lastAction != undefined && b.lastAction != undefined) {
      const lastActionComparison = b.lastAction.seconds - a.lastAction.seconds;
      if (lastActionComparison !== 0) {
        return lastActionComparison;
      }
      return b.notification - a.notification;
    }
  });

  return tempList;
};



export const { reset, setSelectedConversation, setMessage, clearSelectedConversation, setShowArchive, setSearch, readAllChats, setUnreadChat } = messagingSlice.actions;
export const selectSelectedConversation = (state) => state.messaging.selectedConversation
export const selectMessage = (state) => state.messaging.message
export const selectCustomAuthToken = (state) => state.messaging.customAuthToken

export const selectSearch = (state) => state.messaging.search

export const selectSupportDesk = (state) => state.messaging.supportDesk
export const selectSupportDeskStatus = (state) => state.messaging.supportDeskStatus
export const selectAllSupportDesks = (state) => state.messaging.allSupportDesks

export const selectCreateSupportDeskStatus = (state) => state.messaging.createSupportDeskStatus;

export const selectNotificationStatus = (state) => state.messaging.notificationStatus

export const selectFetchConversationsStatus = (state) => state.messaging.fetchConversationStatus
export const selectSendMessageStatus = (state) => state.messaging.postMessageStatus
export const selectDeleteStatus = (state) => state.messaging.deleteStatus
export const selectArchiveChatStatus = (state) => state.messaging.archiveChatStatus
export const selectFetchMessagesStatus = (state) => state.messaging.fetchMessagesStatus

export const selectShowArchive = (state) => state.messaging.showArchive
export const selectFetchNameStatus = (state) => state.messaging.nameFetchStatus
export const selectCustomAuthTokenStatus = (state) => state.messaging.customTokenStatus;
export const selectUnreadChatsCount = state => state.messaging.unreadChats

export default messagingSlice.reducer;
